/**
 * Callback
 *
 * @author edmsamuel
 */
export default class Callback {
  /**
   * Ejecutar método
   *
   * @param {function} fn
   * @param {Any} params
   */
  static execute(fn, ...args) {
    if (typeof fn === 'function') {
      fn(...args);
    }
  }
}
